import { Stack } from '@mantine/core'
import type { ChatMessageWithSender } from '@markku/types'
import { MessageItem } from './MessageItem'

interface MessageListProps {
  messages: ChatMessageWithSender[]
  currentUserId: number
  onDeleteMessage?: (messageId: number) => void
  lastMessageRef?: (node: HTMLDivElement | null) => void
}

export function MessageList({
  messages,
  currentUserId,
  onDeleteMessage,
  lastMessageRef,
}: MessageListProps) {
  return (
    <Stack gap={0}>
      {messages.map((message, index) => {
        // Show author name if:
        // 1. It's the first message
        // 2. The previous message was from a different sender
        const showAuthor =
          index === 0 || messages[index - 1].senderId !== message.senderId

        // Add extra spacing between messages from different authors
        const addSpacing =
          index > 0 && messages[index - 1].senderId !== message.senderId

        const isLastMessage = index === messages.length - 1

        return (
          <div
            key={message.id}
            ref={isLastMessage ? lastMessageRef : undefined}
            style={{ marginTop: addSpacing ? 16 : 4 }}
          >
            <MessageItem
              message={message}
              isOwn={message.senderId === currentUserId}
              showAuthor={showAuthor}
              onDelete={onDeleteMessage}
            />
          </div>
        )
      })}
    </Stack>
  )
}
